"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _PointLocator = _interopRequireDefault(require("../../algorithm/PointLocator"));

var _Location = _interopRequireDefault(require("../../geom/Location"));

var _EdgeNodingValidator = _interopRequireDefault(require("../../geomgraph/EdgeNodingValidator"));

var _GeometryCollectionMapper = _interopRequireDefault(require("../../geom/util/GeometryCollectionMapper"));

var _PolygonBuilder = _interopRequireDefault(require("./PolygonBuilder"));

var _Position = _interopRequireDefault(require("../../geomgraph/Position"));

var _IllegalArgumentException = _interopRequireDefault(require("../../../../../java/lang/IllegalArgumentException"));

var _MapOp = _interopRequireDefault(require("../../geom/util/MapOp"));

var _LineBuilder = _interopRequireDefault(require("./LineBuilder"));

var _PointBuilder = _interopRequireDefault(require("./PointBuilder"));

var _SnapIfNeededOverlayOp = _interopRequireDefault(require("./snap/SnapIfNeededOverlayOp"));

var _Label = _interopRequireDefault(require("../../geomgraph/Label"));

var _OverlayNodeFactory = _interopRequireDefault(require("./OverlayNodeFactory"));

var _GeometryGraphOperation = _interopRequireDefault(require("../GeometryGraphOperation"));

var _EdgeList = _interopRequireDefault(require("../../geomgraph/EdgeList"));

var _ArrayList = _interopRequireDefault(require("../../../../../java/util/ArrayList"));

var _Assert = _interopRequireDefault(require("../../util/Assert"));

var _PlanarGraph = _interopRequireDefault(require("../../geomgraph/PlanarGraph"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var OverlayOp =
/*#__PURE__*/
function (_GeometryGraphOperati) {
  _inherits(OverlayOp, _GeometryGraphOperati);

  function OverlayOp() {
    var _this;

    _classCallCheck(this, OverlayOp);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OverlayOp).call(this));
    OverlayOp.constructor_.apply(_assertThisInitialized(_this), arguments);
    return _this;
  }

  _createClass(OverlayOp, [{
    key: "insertUniqueEdge",
    value: function insertUniqueEdge(e) {
      var existingEdge = this._edgeList.findEqualEdge(e);

      if (existingEdge !== null) {
        var existingLabel = existingEdge.getLabel();
        var labelToMerge = e.getLabel();

        if (!existingEdge.isPointwiseEqual(e)) {
          labelToMerge = new _Label.default(e.getLabel());
          labelToMerge.flip();
        }

        var depth = existingEdge.getDepth();

        if (depth.isNull()) {
          depth.add(existingLabel);
        }

        depth.add(labelToMerge);
        existingLabel.merge(labelToMerge);
      } else {
        this._edgeList.add(e);
      }
    }
  }, {
    key: "getGraph",
    value: function getGraph() {
      return this._graph;
    }
  }, {
    key: "cancelDuplicateResultEdges",
    value: function cancelDuplicateResultEdges() {
      for (var it = this._graph.getEdgeEnds().iterator(); it.hasNext();) {
        var de = it.next();
        var sym = de.getSym();

        if (de.isInResult() && sym.isInResult()) {
          de.setInResult(false);
          sym.setInResult(false);
        }
      }
    }
  }, {
    key: "isCoveredByLA",
    value: function isCoveredByLA(coord) {
      if (this.isCovered(coord, this._resultLineList)) return true;
      if (this.isCovered(coord, this._resultPolyList)) return true;
      return false;
    }
  }, {
    key: "computeGeometry",
    value: function computeGeometry(resultPointList, resultLineList, resultPolyList, opcode) {
      var geomList = new _ArrayList.default();
      geomList.addAll(resultPointList);
      geomList.addAll(resultLineList);
      geomList.addAll(resultPolyList);
      if (geomList.isEmpty()) return OverlayOp.createEmptyResult(opcode, this._arg[0].getGeometry(), this._arg[1].getGeometry(), this._geomFact);
      return this._geomFact.buildGeometry(geomList);
    }
  }, {
    key: "mergeSymLabels",
    value: function mergeSymLabels() {
      for (var nodeit = this._graph.getNodes().iterator(); nodeit.hasNext();) {
        var node = nodeit.next();
        node.getEdges().mergeSymLabels();
      }
    }
  }, {
    key: "isCovered",
    value: function isCovered(coord, geomList) {
      for (var it = geomList.iterator(); it.hasNext();) {
        var geom = it.next();

        var loc = this._ptLocator.locate(coord, geom);

        if (loc !== _Location.default.EXTERIOR) return true;
      }

      return false;
    }
  }, {
    key: "replaceCollapsedEdges",
    value: function replaceCollapsedEdges() {
      var newEdges = new _ArrayList.default();

      for (var it = this._edgeList.iterator(); it.hasNext();) {
        var e = it.next();

        if (e.isCollapsed()) {
          it.remove();
          newEdges.add(e.getCollapsedEdge());
        }
      }

      this._edgeList.addAll(newEdges);
    }
  }, {
    key: "updateNodeLabelling",
    value: function updateNodeLabelling() {
      for (var nodeit = this._graph.getNodes().iterator(); nodeit.hasNext();) {
        var node = nodeit.next();
        var lbl = node.getEdges().getLabel();
        node.getLabel().merge(lbl);
      }
    }
  }, {
    key: "getResultGeometry",
    value: function getResultGeometry(overlayOpCode) {
      this.computeOverlay(overlayOpCode);
      return this._resultGeom;
    }
  }, {
    key: "insertUniqueEdges",
    value: function insertUniqueEdges(edges) {
      for (var i = edges.iterator(); i.hasNext();) {
        var e = i.next();
        this.insertUniqueEdge(e);
      }
    }
  }, {
    key: "computeOverlay",
    value: function computeOverlay(opCode) {
      this.copyPoints(0);
      this.copyPoints(1);

      this._arg[0].computeSelfNodes(this._li, false);

      this._arg[1].computeSelfNodes(this._li, false);

      this._arg[0].computeEdgeIntersections(this._arg[1], this._li, true);

      var baseSplitEdges = new _ArrayList.default();

      this._arg[0].computeSplitEdges(baseSplitEdges);

      this._arg[1].computeSplitEdges(baseSplitEdges);

      var splitEdges = baseSplitEdges;
      this.insertUniqueEdges(baseSplitEdges);
      this.computeLabelsFromDepths();
      this.replaceCollapsedEdges();

      _EdgeNodingValidator.default.checkValid(this._edgeList.getEdges());

      this._graph.addEdges(this._edgeList.getEdges());

      this.computeLabelling();
      this.labelIncompleteNodes();
      this.findResultAreaEdges(opCode);
      this.cancelDuplicateResultEdges();
      var polyBuilder = new _PolygonBuilder.default(this._geomFact);
      polyBuilder.add(this._graph);
      this._resultPolyList = polyBuilder.getPolygons();
      var lineBuilder = new _LineBuilder.default(this, this._geomFact, this._ptLocator);
      this._resultLineList = lineBuilder.build(opCode);
      var pointBuilder = new _PointBuilder.default(this, this._geomFact, this._ptLocator);
      this._resultPointList = pointBuilder.build(opCode);
      this._resultGeom = this.computeGeometry(this._resultPointList, this._resultLineList, this._resultPolyList, opCode);
    }
  }, {
    key: "labelIncompleteNode",
    value: function labelIncompleteNode(n, targetIndex) {
      var loc = this._ptLocator.locate(n.getCoordinate(), this._arg[targetIndex].getGeometry());

      n.getLabel().setLocation(targetIndex, loc);
    }
  }, {
    key: "copyPoints",
    value: function copyPoints(argIndex) {
      for (var i = this._arg[argIndex].getNodeIterator(); i.hasNext();) {
        var graphNode = i.next();

        var newNode = this._graph.addNode(graphNode.getCoordinate());

        newNode.setLabel(argIndex, graphNode.getLabel().getLocation(argIndex));
      }
    }
  }, {
    key: "findResultAreaEdges",
    value: function findResultAreaEdges(opCode) {
      for (var it = this._graph.getEdgeEnds().iterator(); it.hasNext();) {
        var de = it.next();
        var label = de.getLabel();

        if (label.isArea() && !de.isInteriorAreaEdge() && OverlayOp.isResultOfOp(label.getLocation(0, _Position.default.RIGHT), label.getLocation(1, _Position.default.RIGHT), opCode)) {
          de.setInResult(true);
        }
      }
    }
  }, {
    key: "computeLabelsFromDepths",
    value: function computeLabelsFromDepths() {
      for (var it = this._edgeList.iterator(); it.hasNext();) {
        var e = it.next();
        var lbl = e.getLabel();
        var depth = e.getDepth();

        if (!depth.isNull()) {
          depth.normalize();

          for (var i = 0; i < 2; i++) {
            if (!lbl.isNull(i) && lbl.isArea() && !depth.isNull(i)) {
              if (depth.getDelta(i) === 0) {
                lbl.toLine(i);
              } else {
                _Assert.default.isTrue(!depth.isNull(i, _Position.default.LEFT), "depth of LEFT side has not been initialized");

                lbl.setLocation(i, _Position.default.LEFT, depth.getLocation(i, _Position.default.LEFT));

                _Assert.default.isTrue(!depth.isNull(i, _Position.default.RIGHT), "depth of RIGHT side has not been initialized");

                lbl.setLocation(i, _Position.default.RIGHT, depth.getLocation(i, _Position.default.RIGHT));
              }
            }
          }
        }
      }
    }
  }, {
    key: "computeLabelling",
    value: function computeLabelling() {
      for (var nodeit = this._graph.getNodes().iterator(); nodeit.hasNext();) {
        var node = nodeit.next();
        node.getEdges().computeLabelling(this._arg);
      }

      this.mergeSymLabels();
      this.updateNodeLabelling();
    }
  }, {
    key: "labelIncompleteNodes",
    value: function labelIncompleteNodes() {
      var nodeCount = 0;

      for (var ni = this._graph.getNodes().iterator(); ni.hasNext();) {
        var n = ni.next();
        var label = n.getLabel();

        if (n.isIsolated()) {
          nodeCount++;
          if (label.isNull(0)) this.labelIncompleteNode(n, 0);else this.labelIncompleteNode(n, 1);
        }

        n.getEdges().updateLabelling(label);
      }
    }
  }, {
    key: "isCoveredByA",
    value: function isCoveredByA(coord) {
      if (this.isCovered(coord, this._resultPolyList)) return true;
      return false;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return OverlayOp;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "overlayOp",
    value: function overlayOp(geom0, geom1, opCode) {
      var gov = new OverlayOp(geom0, geom1);
      var geomOv = gov.getResultGeometry(opCode);
      return geomOv;
    }
  }, {
    key: "union",
    value: function union(geom, other) {
      if (geom.isEmpty() || other.isEmpty()) {
        if (geom.isEmpty() && other.isEmpty()) return OverlayOp.createEmptyResult(OverlayOp.UNION, geom, other, geom.getFactory());
        if (geom.isEmpty()) return other.copy();
        if (other.isEmpty()) return geom.copy();
      }

      if (geom.isGeometryCollection() || other.isGeometryCollection()) throw new _IllegalArgumentException.default("This method does not support GeometryCollection arguments");
      return _SnapIfNeededOverlayOp.default.overlayOp(geom, other, OverlayOp.UNION);
    }
  }, {
    key: "intersection",
    value: function intersection(geom, other) {
      if (geom.isEmpty() || other.isEmpty()) return OverlayOp.createEmptyResult(OverlayOp.INTERSECTION, geom, other, geom.getFactory());

      if (geom.isGeometryCollection()) {
        var g2 = other;
        return _GeometryCollectionMapper.default.map(geom, new (
        /*#__PURE__*/
        function () {
          function _class() {
            _classCallCheck(this, _class);
          }

          _createClass(_class, [{
            key: "map",
            value: function map(g) {
              return OverlayOp.intersection(g, g2);
            }
          }, {
            key: "interfaces_",
            get: function get() {
              return [_MapOp.default];
            }
          }]);

          return _class;
        }())());
      }

      return _SnapIfNeededOverlayOp.default.overlayOp(geom, other, OverlayOp.INTERSECTION);
    }
  }, {
    key: "symDifference",
    value: function symDifference(geom, other) {
      if (geom.isEmpty() || other.isEmpty()) {
        if (geom.isEmpty() && other.isEmpty()) return OverlayOp.createEmptyResult(OverlayOp.SYMDIFFERENCE, geom, other, geom.getFactory());
        if (geom.isEmpty()) return other.copy();
        if (other.isEmpty()) return geom.copy();
      }

      if (geom.isGeometryCollection() || other.isGeometryCollection()) throw new _IllegalArgumentException.default("This method does not support GeometryCollection arguments");
      return _SnapIfNeededOverlayOp.default.overlayOp(geom, other, OverlayOp.SYMDIFFERENCE);
    }
  }, {
    key: "resultDimension",
    value: function resultDimension(opCode, g0, g1) {
      var dim0 = g0.getDimension();
      var dim1 = g1.getDimension();
      var resultDimension = -1;

      switch (opCode) {
        case OverlayOp.INTERSECTION:
          resultDimension = Math.min(dim0, dim1);
          break;

        case OverlayOp.UNION:
          resultDimension = Math.max(dim0, dim1);
          break;

        case OverlayOp.DIFFERENCE:
          resultDimension = dim0;
          break;

        case OverlayOp.SYMDIFFERENCE:
          resultDimension = Math.max(dim0, dim1);
          break;
      }

      return resultDimension;
    }
  }, {
    key: "createEmptyResult",
    value: function createEmptyResult(overlayOpCode, a, b, geomFact) {
      var result = null;

      switch (OverlayOp.resultDimension(overlayOpCode, a, b)) {
        case -1:
          result = geomFact.createGeometryCollection();
          break;

        case 0:
          result = geomFact.createPoint();
          break;

        case 1:
          result = geomFact.createLineString();
          break;

        case 2:
          result = geomFact.createPolygon();
          break;
      }

      return result;
    }
  }, {
    key: "difference",
    value: function difference(geom, other) {
      if (geom.isEmpty()) return OverlayOp.createEmptyResult(OverlayOp.DIFFERENCE, geom, other, geom.getFactory());
      if (other.isEmpty()) return geom.copy();
      if (geom.isGeometryCollection() || other.isGeometryCollection()) throw new _IllegalArgumentException.default("This method does not support GeometryCollection arguments");
      return _SnapIfNeededOverlayOp.default.overlayOp(geom, other, OverlayOp.DIFFERENCE);
    }
  }, {
    key: "isResultOfOp",
    value: function isResultOfOp() {
      if (arguments.length === 2) {
        var label = arguments[0],
            opCode = arguments[1];
        var loc0 = label.getLocation(0);
        var loc1 = label.getLocation(1);
        return OverlayOp.isResultOfOp(loc0, loc1, opCode);
      } else if (arguments.length === 3) {
        var _loc = arguments[0],
            _loc2 = arguments[1],
            overlayOpCode = arguments[2];
        if (_loc === _Location.default.BOUNDARY) _loc = _Location.default.INTERIOR;
        if (_loc2 === _Location.default.BOUNDARY) _loc2 = _Location.default.INTERIOR;

        switch (overlayOpCode) {
          case OverlayOp.INTERSECTION:
            return _loc === _Location.default.INTERIOR && _loc2 === _Location.default.INTERIOR;

          case OverlayOp.UNION:
            return _loc === _Location.default.INTERIOR || _loc2 === _Location.default.INTERIOR;

          case OverlayOp.DIFFERENCE:
            return _loc === _Location.default.INTERIOR && _loc2 !== _Location.default.INTERIOR;

          case OverlayOp.SYMDIFFERENCE:
            return _loc === _Location.default.INTERIOR && _loc2 !== _Location.default.INTERIOR || _loc !== _Location.default.INTERIOR && _loc2 === _Location.default.INTERIOR;
        }

        return false;
      }
    }
  }]);

  return OverlayOp;
}(_GeometryGraphOperation.default);

exports.default = OverlayOp;

OverlayOp.constructor_ = function () {
  this._ptLocator = new _PointLocator.default();
  this._geomFact = null;
  this._resultGeom = null;
  this._graph = null;
  this._edgeList = new _EdgeList.default();
  this._resultPolyList = new _ArrayList.default();
  this._resultLineList = new _ArrayList.default();
  this._resultPointList = new _ArrayList.default();
  var g0 = arguments[0],
      g1 = arguments[1];

  _GeometryGraphOperation.default.constructor_.call(this, g0, g1);

  this._graph = new _PlanarGraph.default(new _OverlayNodeFactory.default());
  this._geomFact = g0.getFactory();
};

OverlayOp.INTERSECTION = 1;
OverlayOp.UNION = 2;
OverlayOp.DIFFERENCE = 3;
OverlayOp.SYMDIFFERENCE = 4;